import { plannerAcceptRequestSchema, plannerAcceptResponseSchema, plannerSwapFeedbackRequestSchema, plannerSwapFeedbackResponseSchema, plannerWeekRequestSchema, plannerWeekResponseSchema, } from '@fewerbags/schema';
/**
 * /api/v1/planner — "Plan my week" (D29). `week` proposes (nothing is stored);
 * `accept` creates the meal plans and, optionally, a grocery list for the range.
 * v2 (D33): slots, attendees, vibe, cuisines, budget, dine-out and packed meals
 * on `week`; kinds, places, attendees and costs on `accept`; `swapFeedback`.
 */
export function createPlannerApi(http, base) {
    return {
        /** A proposal for each day; swap = call again with that day's pick in `exclude`. */
        week: async (input) => http.post(`${base}/week`, plannerWeekRequestSchema.parse(input), {
            parse: plannerWeekResponseSchema,
        }),
        /** Create the accepted plans (and a grocery list when asked). */
        accept: async (input) => http.post(`${base}/week/accept`, plannerAcceptRequestSchema.parse(input), {
            parse: plannerAcceptResponseSchema,
        }),
        /** "I swapped this": `didnt_want` teaches the attendees' learned dislikes (D31). */
        swapFeedback: async (input) => http.post(`${base}/week/swap-feedback`, plannerSwapFeedbackRequestSchema.parse(input), {
            parse: plannerSwapFeedbackResponseSchema,
        }),
    };
}
//# sourceMappingURL=planner.js.map